import { render, staticRenderFns } from "./noticeTable.vue?vue&type=template&id=8d1c7f46&scoped=true"
import script from "./noticeTable.vue?vue&type=script&lang=js"
export * from "./noticeTable.vue?vue&type=script&lang=js"
import style0 from "./noticeTable.vue?vue&type=style&index=0&id=8d1c7f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c7f46",
  null
  
)

export default component.exports